import { useState } from 'react';
import { Box } from '@material-ui/core';

import { usePreviewStyles } from 'componentsV2/pdf-preview-dialog';

import { UnavailableContent } from '../unavailable-content';

interface VideoContentProps {
  url: string;
  onOpenFile: () => void;
}

/** The browser's video player; a format it cannot play (some MOV files)
 *  falls back to the "not available" state instead of a blank player. */
export const VideoContent = ({ url, onOpenFile }: VideoContentProps) => {
  const classes = usePreviewStyles();
  const [failed, setFailed] = useState(false);

  if (failed) return <UnavailableContent onOpenFile={onOpenFile} />;

  return (
    <Box className={classes.scrollArea}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        controls
        src={url}
        onError={() => setFailed(true)}
        style={{
          margin: 'auto',
          maxWidth: '100%',
          maxHeight: '100%',
          borderRadius: 8,
          background: '#000'
        }}
      />
    </Box>
  );
};
